import { useQuery } from '@tanstack/react-query'
import { Logger } from '@core/logger'
import { useCurrentUser } from '@features/session'
import { SubscriptionQueryKey } from '../helpers/queryKeys'
import { getPlan } from '../services/getPlan'

/**
 * The signed-in user's subscription plan (`billing/plan`). Enabled only for authenticated users
 * (guests have no plan). Mirrors audio-web `usePlan`. react-query is the current data-layer
 * scaffolding (off-react-query is MI2-2056).
 */
export const usePlan = () => {
    const { id: userId } = useCurrentUser()

    return useQuery({
        enabled: userId !== 0,
        queryKey: SubscriptionQueryKey.subscriptionPlan(),
        queryFn: async ({ signal }) => {
            try {
                return await getPlan({ signal })
            } catch (error) {
                if (!signal.aborted) {
                    Logger.error('Failed to fetch the subscription plan', { error })
                }

                throw error
            }
        },
    })
}
